    <div class="container-fluid page-content">
        <div class="row justify-content-center align-items-center mb-1" style="width: 100%; margin-right: 0px;margin-left: 0px;">
            <div class="col-lg-10 col-md-10 col-sm-8 col-8">
                <label class="title">Activos</label>
            </div>
            <div class="col-lg-2 col-md-2 col-sm-4 col-4 justify-content-end align-items-end text-end">
                <div class="btn-group side-space">
                    <button type="button" class="btn btn-link rounded-button dropdown-toggle" role="menu" id="dropdownOpciones" data-bs-toggle="dropdown" aria-expanded="false">
                        Más opciones
                    </button>
                    <div class="dropdown-menu" style="margin-right: 100px; width: 250px;" aria-labelledby="dropdownOpciones">
                        <button (click)="abrirModalCrearActivo()" style="width: 220px; " class="mt-1 btn btn-sm btn-success rounded-button side-space">
                            <i class="fas fa-plus"></i>&nbsp;
                            Nuevo Activo
                        </button>
                        <button (click)="abrirModalCuentaCredito()" style="width: 220px; " class="mt-1 btn btn-sm my-button-blue-primary rounded-button side-space">
                            <i class="fas fa-credit-card"></i>&nbsp;
                            Configuración Global
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <!--Busqueda-->
        <div class="card mt-1" style="border-radius: 12px;">
            <div class="card-body" style="padding-top: 18px; padding-bottom: 18px;">
                <form #formSearchCargas="ngForm" (ngSubmit)="getEquipos();" novalidate="">
                    <div class="row">
                        <div class="col col-lg-5 col-md-5 col-sm-12 col-12">
                            <div class="form-group">
                                <label class="mb-2">Activo </label>
                                <br>
                                <input type="text" class="form-control custom-input form-control-sm" name="txtActivo"  autocomplete="off" #txtActivo="ngModel" [(ngModel)]="busquedaRQ.numActivo" placeholder="Todos los activos">
                            </div>
                        </div>
                        <div class="col col-lg-5 col-md-5 col-sm-12 col-12">
                            <div class="form-group">
                                <label class="mb-2"> Ubicación </label>
                                <br>
                                <p-dropdown [disabled]="!isAdmin" name="slcEstaciones" #slcEstaciones="ngModel" [options]="estaciones" [filter]="true" filterBy="label" [style]="{'width':'100%'}" [showClear]="true" placeholder="Todas las estaciones" [(ngModel)]="busquedaRQ.estacion"
                                    styleClass="custom-input" optionValue="value" optionLabel="label">
                                </p-dropdown>
                            </div>
                        </div>

                        <div class="col col-lg-2 col-md-4 col-sm-12 col-12">
                            <div class="form-group">
                                <button style="margin-top: 31px; width: 100%;" class="btn my-button-blue-outline btn-sm btn-block rounded-button">
                                    <i class="fas fa-search"></i>&nbsp;Buscar
                                </button>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
        </div>

        <div class="row mt-3" style="width: 100%; ">
            <p-table #dt [value]="lista" [scrollable]="true" [scrollHeight]="'calc(100vh - 320px)'" [paginator]="true" [rows]="20" [showCurrentPageReport]="true" currentPageReportTemplate="Mostrando {first} a {last} de {totalRecords}" [rowsPerPageOptions]="[20,50,100,200]">

                <ng-template pTemplate="header">
                    <tr>
                        <th pSortableColumn="Activo" class="medium-col" style="border-top-left-radius: 15px;"> Activo</th>
                        <th pSortableColumn="Descripcion" class="medium-col">Descripción</th>
                        <th pSortableColumn="Ubicacion" class="medium-col">Ubicación</th>
                        <th pSortableColumn="CuentaLM" class="medium-col">Cuenta LM</th>
                        <th pSortableColumn="Estado" class="medium-col">Estado</th>
                        <th pSortableColumn="Compania" class="medium-col">Compañia</th>
                        <!-- <th pSortableColumn="Tipo" class="medium-col">Tipo</th> -->
                        <!-- <th pSortableColumn="Anio" class="medium-col">Año</th> -->
                        <th pSortableColumn="Marca" class="medium-col">Marca</th>
                        <th pSortableColumn="Modelo" class="medium-col">Modelo</th>
                        <th pSortableColumn="Familia" class="medium-col">Familia</th>
                        <th pSortableColumn="Capacidad" class="medium-col">Capacidad</th>
                        <th pSortableColumn="Combustible" class="medium-col">Combustible</th>
                        <!-- <th pSortableColumn="Planta" class="medium-col">Planta</th> -->
                        <th class="medium-col" style="border-top-right-radius: 15px;">Acción</th>
                    </tr>

                    <tr class="filter-row">
                        <th>
                            <input placeholder="Filtrar" type="text" #filtroNumeroActivo style="width: 45px;" class="form-input form-input-table-filter" (input)="dt.filter(filtroNumeroActivo.value, 'Activo', 'contains')">
                        </th>

                        <th class="filter-row">
                            <input placeholder="Filtrar" #filtroDescrpcion type="text" class="form-input form-input-table-filter medium-col" (input)="dt.filter(filtroDescrpcion.value, 'Descripcion', 'contains')">

                        </th>
                        <th class="filter-row">
                            <input placeholder="Filtrar" #filtroUbicacion type="text" style="width: 45px;" class="form-input form-input-table-filter" (input)="dt.filter(filtroUbicacion.value, 'Ubicacion', 'contains')">
                        </th>

                        <th class="filter-row">
                            <input placeholder="Filtrar" #filtroCuentaLM type="text" class="form-input form-input-table-filter medium-col" (input)="dt.filter(filtroCuentaLM.value, 'CuentaLM', 'contains')">
                        </th>
                        <th class="filter-row">
                            <input placeholder="Filtrar" #filtroEstado type="text" style="width: 45px;" class="form-input form-input-table-filter" (input)="dt.filter(filtroEstado.value, 'Estado', 'contains')">

                        </th>
                        <th class="filter-row">
                            <input placeholder="Filtrar" #filtroCompania type="text" style="width: 45px;" class="form-input form-input-table-filter" (input)="dt.filter(filtroCompania.value, 'Compania', 'contains')">
                        </th>
                        <!-- <th class="filter-row">
                            <input placeholder="Filtrar" #filtroTipo type="text" style="width: 45px;" class="form-input form-input-table-filter" (input)="dt.filter(filtroTipo.value, 'Tipo', 'contains')">
                        </th> -->
                        <!-- <th class="filter-row">
                            <input placeholder="Filtrar" #filtroAnio type="text" style="width: 45px;" class="form-input form-input-table-filter" (input)="dt.filter(filtroAnio.value, 'Anio', 'contains')">
                        </th> -->
                        <th class="filter-row">
                            <input placeholder="Filtrar" #filtroMarca type="text" style="width: 45px;" class="form-input form-input-table-filter" (input)="dt.filter(filtroMarca.value, 'Marca', 'contains')">
                        </th>
                        <th class="filter-row">
                            <input placeholder="Filtrar" #filtroModelo type="text" style="width: 45px;" class="form-input form-input-table-filter" (input)="dt.filter(filtroModelo.value, 'Modelo', 'contains')">
                        </th>
                        <th class="filter-row">
                            <input placeholder="Filtrar" #filtroFamiliaEquipo type="text" style="width: 45px;" class="form-input form-input-table-filter" (input)="dt.filter(filtroFamiliaEquipo.value, 'Familia', 'contains')">
                        </th>
                        <th class="filter-row">
                            <input placeholder="Filtrar" #filtroCapacidad type="text" style="width: 45px;" class="form-input form-input-table-filter " (input)="dt.filter(filtroCapacidad.value, 'Capacidad', 'contains')">
                        </th>
                        <th class="filter-row">
                            <input placeholder="Filtrar" #filtroCombustible type="text" style="width: 45px;" class="form-input form-input-table-filter" (input)="dt.filter(filtroCombustible.value, 'Combustible', 'contains')">
                        </th>
                        <!-- <th class="filter-row">
                            <input placeholder="Filtrar" #filtroPlanta style="width: 45px;" type="text" class="form-input form-input-table-filter " (input)="dt.filter(filtroPlanta.value, 'Planta', 'contains')">
                        </th> -->

                        <th></th>
                    </tr>
                </ng-template>

                <ng-template pTemplate="body" class="animated fadeIn fast" let-activo>
                    <tr>
                        <td class="medium-col"> <b>{{ activo.Activo }}</b> </td>
                        <td class="medium-col">{{activo.Descripcion}}</td>
                        <td class="medium-col">{{activo.Ubicacion}}</td>
                        <td class="medium-col">{{activo.CuentaLM}}</td>
                        <td class="medium-col">{{activo.Estado}}</td>
                        <td class="medium-col">{{activo.Compania != null ? activo.Compania : 'N/A'}}</td>
                        <!-- <td class="medium-col">{{activo.Tipo}}</td> -->
                        <!-- <td class="medium-col">{{activo.Anio}}</td> -->
                        <td class="medium-col">{{activo.Marca}} </td>
                        <td class="medium-col">{{activo.Modelo}}</td>
                        <td class="medium-col">{{activo.Familia}}</td>
                        <td class="medium-col">{{activo.Capacidad}}</td>
                        <td class="medium-col">{{activo.Combustible}}</td>
                        <!-- <td class="medium-col">{{activo.Planta}}</td> -->
                        <td class="medium-col">
                            <button type="button" (click)="abrirModalEditarActivo(activo)" style="font-size:12px; width: 80px;" class="btn btn-xs my-button-blue-outline rounded-button">
                                <i class="far fa-edit"></i>&nbsp;Editar
                            </button>
                        </td>
                    </tr>
                </ng-template>
            </p-table>
        </div>
    </div>